import React from 'react';
import { MarkDownView } from './MarkDownView';
import { openCookieSettings } from '../../utils/ads';

const privacyPolicy = `
# Politika privatnosti

_Poslednje ažuriranje: 28. oktobar 2026._

Dobrodošli na **Puskica Kviz** platformu. Ova Politika privatnosti objašnjava na koji način prikupljamo, koristimo i štitimo vaše podatke prilikom korišćenja naše aplikacije, sajta i usluga.

Korišćenjem platforme prihvatate praksu opisanu u ovoj Politici privatnosti.

---

# 1. Podaci koje prikupljamo

Možemo prikupljati sledeće vrste podataka:

## Podaci koje korisnik unosi

- Ime i prezime
- Email adresa
- Korisničko ime
- Lozinka (u šifrovanom obliku)
- Profilne informacije

## Podaci o korišćenju platforme

- Rezultati kvizova
- Napredak u učenju
- Statistika korišćenja
- Aktivnosti unutar aplikacije

## Podaci iz kontakt forme

- Ime, e-pošta i tekst poruke koje nam pošaljete. Koristimo ih isključivo da bismo vam odgovorili, a poruke se čuvaju u našem e-mail sandučetu.

## Tehnički podaci

- IP adresa
- Tip uređaja
- Operativni sistem
- Verzija aplikacije
- Informacije o browser-u

---

# 2. Kako koristimo podatke

Prikupljene podatke koristimo za:

- Kreiranje i održavanje korisničkog naloga
- Funkcionisanje platforme
- Personalizaciju korisničkog iskustva
- Praćenje napretka i rezultata
- Poboljšanje performansi i funkcionalnosti
- Komunikaciju sa korisnicima
- Zaštitu bezbednosti platforme

---

# 3. Čuvanje i zaštita podataka

Preduzimamo razumne tehničke i organizacione mere kako bismo zaštitili vaše podatke od:

- Neovlašćenog pristupa
- Gubitka podataka
- Zloupotrebe
- Izmene ili uništavanja podataka

Ipak, nijedan sistem zaštite na internetu ne može garantovati apsolutnu bezbednost.

---

# 4. Deljenje podataka sa trećim stranama

Vaše podatke ne prodajemo trećim stranama.

Podaci mogu biti podeljeni samo u sledećim slučajevima:

- Kada je to zakonski obavezno
- Radi zaštite prava i bezbednosti platforme
- Sa pouzdanim servisima koji pomažu funkcionisanje aplikacije (hosting, analitika i slično), kao i sa Google-om u svrhu analitike i prikaza oglasa, u skladu sa vašim izborom kolačića

Treće strane imaju obavezu zaštite podataka u skladu sa važećim zakonima.

---

# 5. Kolačići, analitika i oglasi

Kolačići su male datoteke koje sajt čuva u vašem browser-u. Kolačiće delimo u tri kategorije, a vi birate koje dozvoljavate:

- **Neophodni** – omogućavaju prijavu, čuvanje napretka i pamćenje vašeg izbora o kolačićima. Uvek su uključeni jer sajt bez njih ne radi.
- **Analitika** – koristimo **Google Analytics** za statistiku posećenosti (koje stranice se posećuju, sa kog uređaja i slično) kako bismo poboljšali sajt. Uključuje se samo uz vašu saglasnost.
- **Oglasi (marketing)** – koristimo **Google AdSense** za prikaz oglasa koji nam omogućavaju da sajt ostane besplatan. Google i njegovi partneri mogu koristiti kolačiće da prikažu relevantne oglase i izmere njihovu efikasnost. Uključuje se samo uz vašu saglasnost.

Dok ne date saglasnost, analitički i oglasni kolačići nisu aktivni i oglasi se ne prikazuju. Izbor možete u svakom trenutku promeniti ili povući dugmetom **Podešavanja kolačića** na dnu ove stranice, kao i kroz podešavanja browser-a.

Više o tome kako Google koristi podatke: [Google Politika privatnosti i uslovi](https://policies.google.com/technologies/partner-sites). Personalizovane oglase možete isključiti i na [Google podešavanjima oglasa](https://adssettings.google.com).

---

# 6. Čuvanje podataka

Podatke čuvamo onoliko dugo koliko je potrebno za:

- Funkcionisanje korisničkog naloga
- Ispunjavanje zakonskih obaveza
- Rešavanje sporova
- Zaštitu platforme

Korisnik može zahtevati brisanje naloga i podataka, osim kada zakon nalaže drugačije čuvanje.

---

# 7. Prava korisnika

Korisnici imaju pravo da:

- Zatraže pristup svojim podacima
- Isprave netačne podatke
- Zatraže brisanje podataka
- Ograniče obradu podataka
- Povuku saglasnost za obradu podataka

Za ostvarivanje prava korisnik nas može kontaktirati putem email adrese navedene ispod.

Ako smatrate da se vaši podaci obrađuju suprotno zakonu, imate pravo da podnesete pritužbu **Povereniku za informacije od javnog značaja i zaštitu podataka o ličnosti** Republike Srbije (poverenik.rs).

Podatke obrađujemo u skladu sa Zakonom o zaštiti podataka o ličnosti Republike Srbije. Pravni osnov obrade je ugovor (korisnički nalog i rad platforme), vaša saglasnost (analitički i oglasni kolačići, kontakt forma) i naš legitimni interes (bezbednost i unapređenje platforme). Saglasnost možete povući u svakom trenutku.

---

# 8. Zaštita dece

Platforma nije namenjena deci mlađoj od 15 godina bez saglasnosti roditelja ili staratelja.

Ukoliko saznamo da su podaci deteta prikupljeni bez odgovarajuće saglasnosti, preduzećemo korake za njihovo uklanjanje.

---

# 9. Izmene politike privatnosti

Zadržavamo pravo izmene ove Politike privatnosti u bilo kom trenutku.

Sve izmene biće objavljene unutar aplikacije ili sajta, a nastavak korišćenja platforme smatraće se prihvatanjem ažurirane politike.

---

# 10. Kontakt

Za pitanja u vezi sa Politikom privatnosti možete nas kontaktirati putem:

- Email adrese: puskica.kviz@gmail.com

Rukovalac podataka i vlasnik platforme: **Marčetić Zoran, Milana Rakića 16, Novi Sad, Srbija**.

---

# 11. Važeće pravo

Na ovu Politiku privatnosti primenjuju se zakoni Republike Srbije, osim ukoliko lokalni propisi korisnika zahtevaju drugačije.

---

# Hvala vam

Hvala vam na poverenju i korišćenju **Puskica Kviz** platforme.
`;

function PrivacyPolicy() {
    return (
        <div className="pb-[120px] w-full items-center flex flex-col bg-white min-h-full">
            <div className="flex flex-col items-center mt-[20px] w-full px-[10px]">
                <div className="w-full max-w-[834px] mt-[20px] pt-[20px] flex flex-col gap-[20px] ">
                    <MarkDownView source={privacyPolicy} style={{ color: 'black', textAlign: 'left', backgroundColor: 'transparent' }}></MarkDownView>
                    <div>
                        <button
                            onClick={openCookieSettings}
                            className="px-4 h-[40px] rounded-[4px] text-[14px] font-semibold bg-blueDark text-white"
                        >
                            Podešavanja kolačića
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
